import React from "react";
import { ButtonTertiaryV2, ButtonPrimaryV2, Modal, UI_BODY_SEMIBOLD } from "oolib";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import styled, { createGlobalStyle } from "styled-components";

const ModalCardStyle = createGlobalStyle`
  #modal-root .StyledModalLargeContentWrapper {
    border: none;
    overflow: hidden;
  }
`;

const StyledDangerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 10px 14px;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;

const StyledCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  background: none;
  padding: 0.4rem;
  cursor: pointer;
  color: inherit;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.4rem;
`;

export const FieldTypeChangeWarningModal = ({ config, onConfirm, onCancel }) => {
  const {
    title,
    confirmText,
    headerBg,
    headerColor,
    render,
    fieldLabel,
    fromDisplay,
    toDisplay,
  } = config;

  return (
  <>
    <ModalCardStyle />
    <Modal
      title={title}
      disableHeader
      fitToContentHeight
      desktopWidth="50rem"
      onClose={onCancel}
      showActionPanel
      showCloseBtn={false}
      // A node rather than a handler, so both buttons render in the designed
      // order — Modal's own pair puts confirm first.
      onConfirm={
        <>
          <ButtonTertiaryV2 onClick={onCancel}>Cancel</ButtonTertiaryV2>
          <ButtonPrimaryV2 onClick={onConfirm}>
            {confirmText}
          </ButtonPrimaryV2>
        </>
      }
      alignActions="right"
    >
      <StyledDangerHeader $bg={headerBg} $color={headerColor}>
        <DisplayIcon
          size={20}
          icon="WarningDiamond"
          weight="fill"
          color={headerColor}
        />
        <UI_BODY_SEMIBOLD style={{ flexGrow: 1, color: headerColor }}>
          {title}
        </UI_BODY_SEMIBOLD>
        <StyledCloseButton onClick={onCancel} aria-label="Cancel">
          <DisplayIcon size={18} icon="X" color={headerColor} />
        </StyledCloseButton>
      </StyledDangerHeader>

      <StyledBody>{render({ fieldLabel, fromDisplay, toDisplay })}</StyledBody>
    </Modal>
  </>
  );
};
